"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteRaceById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Deletes a race by given ID (if it exists).
 *
 * Race is identified by its stringified `ObjectID`.
 *
 * ## Usage
 * ```ts
 * const raceId: string = "57da777687ecf89";
 * const {
 * 	acknowledged,
 * 	deletedCount,
 * } = await deleteRaceById({ raceId });
 * ```
 *
 * @param params.raceId - ID of the race to be deleted.
 */
const deleteRaceById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { raceId } = params;
    const url = `${BASE_URL}/races/race/${raceId}`;
    const raceResponse = yield axios_1.default.delete(url, { validateStatus: () => true });
    const { status, data } = raceResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.deleteRaceById = deleteRaceById;
